import React from "react";
import * as CHQ from "chq";
import { Link } from "react-router-dom";

import { ProfileLink } from "app/links";
import { getImage, Trans } from "app/utils";
import imagesSizes from "constants/imagesSizes";

import NotificationBody from "./NotificationBody";

type StoryAnswerNotificationProps = {
  notification: CHQ.NotificationStoryAnswer;
  tabIndex?: number;
};

const StoryAnswerNotification: React.FC<StoryAnswerNotificationProps> = ({
  notification: { actor, entity, message, imageUrl, imageAlt, smallUrl }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <ProfileLink user={actor} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>
      wants to see your stories for this
      {" "}
      <Link to={`/stories/trend/${entity?.id}`} tabIndex={tabIndex || 0}>
        trend
      </Link>
      :
    </Trans>
    <br />
    {message && (
      <>
        &quot;
        {message}
        &quot;
      </>
    )}
    <hr />
    <Link to={`/stories/trend/${entity?.id}#create`} tabIndex={tabIndex || 0}>{entity?.question}</Link>
    <br />
    <img className="image" src={getImage(imagesSizes.SMALL, smallUrl || imageUrl)} alt={imageAlt} />
  </NotificationBody>
);

export default StoryAnswerNotification;
